import projection from '../generated/pwc202f1.json';
import { AcceptanceManifest } from '../types';

/** Generated by scripts/build-acceptance-projections.js from the canonical Contract. */
export const pwc202f1AcceptanceManifest = projection as AcceptanceManifest;
